export default __webpack_public_path__ + "static/media/logo-vw-comerciales-white.e99517a1.svg";